import { t } from "@/i18n-js/instance";
import type { ButtonProps } from "@circle-react-uikit/Button";
import { Button } from "@circle-react-uikit/Button";

export interface SaveButtonProps extends ButtonProps {
  formId?: string;
}

export const SaveButton = ({
  onClick,
  variant = "primary",
  formId,
  children,
  ...rest
}: SaveButtonProps) => {
  const buttonProps: Partial<ButtonProps> = formId
    ? { form: formId, type: "submit" }
    : { type: "button" };

  return (
    <Button variant={variant} onClick={onClick} {...buttonProps} {...rest}>
      {children || t("save")}
    </Button>
  );
};
